import React from "react";
import { UseFormReturn } from "react-hook-form";
import CustomInput from "src/components/CustomInput";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";

import { Button } from "src/components/ui/button";
import { ItemStockUnitFormType } from "./api/interfaces";
import { Form } from "src/components/ui/form";

interface ItemStockUnitFormModalProps {
  isShow: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: UseFormReturn<ItemStockUnitFormType, any, any>;
  type: "CREATE" | "EDIT";
}

const ItemStockUnitFormModal: React.FC<ItemStockUnitFormModalProps> = ({
  isShow,
  onClose,
  onSubmit,
  form,
  type,
}) => {
  return (
    <Dialog open={isShow} onOpenChange={onClose}>
      <DialogContent className="max-w-fit">
        <DialogHeader>
          <DialogTitle className="text-md font-semibold text-darkBrown-default">
            {`${type === "CREATE" ? "Create" : "Edit"} Item Stock Unit`}
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 pt-2 w-[860px]">
          <Form {...form}>
            <div className="w-full grid gap-4 mb-12">
              <CustomInput
                form={form}
                name="name"
                labelText="Stock Unit Name"
                placeholder="Input Name"
              />

              <CustomInput
                form={form}
                name="description"
                labelText="Description (Optional)"
                placeholder="Input Description"
                textArea
                maxCharacters={1000}
              />
            </div>
          </Form>
        </div>

        <DialogFooter>
          <Button onClick={onSubmit} isLoading={form.formState.isSubmitting}>
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ItemStockUnitFormModal;
